import { NgModule } from "@angular/core";
import { LoggedInGuard } from 'src/app/guards/logged-in.guard';
import { RouterModule, Routes } from '@angular/router';
import { PagesComponent } from '../pages.component';
import { InvoicerReactivoComponent } from './invoicer-reactivo/invoicer-reactivo.component';

const routes: Routes = [
  {
    path: 'Invoice', component: PagesComponent, canActivate: [LoggedInGuard], children: [
      { path: '', component: InvoicerReactivoComponent, canActivate: [LoggedInGuard] }]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class InvoiceRoutingModule { }
